import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseData } from '../interfaces/response.interface';
import { WheelCondition, WheelHistory, WheelInfo, WheelPrize } from '../interfaces/wheel.interface';
import { BaseApi } from './base.api';

@Injectable({
  providedIn: 'root',
})
export class WheelApi extends BaseApi {
  /**
   * 转动轮盘
   *
   * @param activityCode 活动id
   * @returns
   */
  turntablerun(activityCode: string): Observable<ResponseData<WheelPrize>> {
    const url = `${environment.apiUrl}/v1/resource/activity/turntablerun`;
    return this.post(url, { activityCode, calcPayout: true });
  }

  /**
   * 获取活动资讯
   *
   * @returns
   */
  getturntableinformation(): Observable<ResponseData<WheelInfo[]>> {
    const url = `${environment.apiUrl}/v1/resource/activity/getmoreturntableinformation`;
    return this.get(url);
  }

  /**
   * 取得剩余次数、距离下次抽奖的条件
   *
   * @param activityCode 活动id
   * @returns
   */
  getturntablegaptospin(activityCode: string): Observable<ResponseData<WheelCondition>> {
    const url = `${environment.apiUrl}/v1/resource/activity/getturntablegaptospin`;
    return this.get(url, { activityCode });
  }

  /**
   * 获取大转盘中奖历史（所有人）
   *
   * @param startTime 开始时间
   * @param endTime 结束时间
   * @param pageIndex 当前页码
   * @param pageSize 每页条数
   * @returns
   */
  getturntableprizehistory(
    startTime: number,
    endTime: number,
    pageIndex: number,
    pageSize: number
  ): Observable<ResponseData<WheelHistory>> {
    const url = `${environment.apiUrl}/v1/resource/activity/GetTurntablePrizesHistory`;
    return this.get(url, { startTime, endTime, pageIndex, pageSize });
  }

  /**
   * 获取大转盘转动历史（用户自己）
   *
   * @param startTime 开始时间
   * @param endTime 结束时间
   * @param pageIndex 当前页码
   * @param pageSize 每页条数
   * @returns
   */
  getturntablspinhistory(
    startTime: number,
    endTime: number,
    pageIndex: number,
    pageSize: number
  ): Observable<ResponseData<WheelHistory>> {
    const url = `${environment.apiUrl}/v1/resource/activity/getturntablspinhistory`;
    return this.get(url, { startTime, endTime, pageIndex, pageSize });
  }
}
